import type { PropertyFormData } from '../types';

export const PROPERTY_FIELD_LABELS: Record<string, string> = {
	name: 'Nome',
	state: 'Estado',
	subscription: 'Inscrição',
	cep: 'CEP',
	city: 'Cidade',
	street: 'Logradouro',
	district: 'Bairro',
	number: 'Número',
};

export const DEFAULT_PROPERTY_FORM: PropertyFormData = {
	id: '',
	name: '',
	subscription: '',
	state: '',
	cep: '',
	city: '',
	street: '',
	district: '',
	number: '',
};
